module.exports = __webpack_public_path__ + "img/google-play-badge.f01e0c41.png";